// extracted by mini-css-extract-plugin
export default {"readOnly":"ChannelSelect_readOnly__3iizA"};